//@ts-check
import {CustomDataTable} from '@/components/organisms'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useComboProductTable} from '@/hooks/productCombo/useComboProductTable'
import {DEFAULT_TABLE_PAGE_SIZE} from '@/utils/constants/commonConstants'
import {comboProductTableColumns} from '@/utils/productCombo/productComboConstants'
import {Font} from 'pepsico-ds'
import {useEffect, useRef} from 'react'

export const ComboProductTable = () => {
  const {
    data,
    setSortingObj,
    setSearchArry,
    onPageIndexChange,
    isLoading,
    handleResetAll,
    onRowSelection,
    isSelectAll,
    handleIsSelectAll,
  } = useComboProductTable()
  const {
    productCombo: {comboSkus, productLimit, displayCategoryIds},
  } = useProductCombo()
  const tableRef = useRef(null)
  const selectedCategoryCount = displayCategoryIds?.length ?? 0

  useEffect(() => {
    // Dropdown options can still be loading while the combo already has category IDs.
    if (selectedCategoryCount === 0) {
      tableRef?.current?.resetAll()
    }
  }, [selectedCategoryCount])

  return (
    <div className="flex flex-col gap-6 rounded-lg bg-gray-850 p-6">
      <Font variant="bold">Product Table</Font>
      <CustomDataTable
        columns={comboProductTableColumns}
        records={data?.data || []}
        setSearchArry={setSearchArry}
        handleSorting={setSortingObj}
        setPageIndex={onPageIndexChange}
        totalRecords={data?.totalRecords || 0}
        pageSize={DEFAULT_TABLE_PAGE_SIZE}
        onResetAll={handleResetAll}
        onRowSelect={onRowSelection}
        isLoading={isLoading}
        showActions={false}
        id="productId"
        initialSelectedRows={comboSkus ?? []}
        showResetAll={true}
        isSelectAll={isSelectAll}
        setSelectAll={handleIsSelectAll}
        defaultSortConfig={{key: 'productId', direction: 'desc'}}
        selectionError={
          typeof productLimit === 'number' && comboSkus && comboSkus.length > productLimit
            ? `Selection limit reached. You can select a maximum of ${productLimit} records based on the Product Limit value.`
            : undefined
        }
        ref={tableRef}
      />
    </div>
  )
}
